<template>
  <div>
    <!-- RM Watches -->
    <div v-if="route === 'rm-watches'">
      <div v-for="(watch, index) in rmWatches" :key="watch.SKU">
        <div
          class="page-grid"
          v-if="
            (loop === 0 && watch.SKU === featuredRM.first) ||
            (loop === 1 && watch.SKU === featuredRM.second) ||
            (loop === 2 && watch.SKU === featuredRM.third) ||
            (loop === 3 && watch.SKU === featuredRM.fourth)
          "
        >
          <article class="grid-container image-right columns-two border no-gap">
            <section class="section1">
              <span v-for="(img, idx) in featuredRMWatchesImgs" :key="img[0].SKU">
                <div
                  v-if="watch.SKU === img[0].SKU"
                  class="bg-image"
                  :style="{ backgroundImage: 'url(/watches/gallery/NW-' + watch.SKU + '/gallery-small-image/' + img[0].name + ')' }"
                ></div>
              </span>
            </section>

            <section class="section2 transparent">
              <div>
                <h2>{{ watch.Name }}</h2>
                <div>
                  <p class="center">

                    <template v-if="watch.StatusName === 'Sold'">
                      <span>Sold</span>
                    </template>
                    
                    <template v-else>
                      <span class="status">{{ watch.StatusName }}
                        <span>&nbsp;|&nbsp;&nbsp;</span>
                      </span>
                        <span v-if="watch.isPOA" class="price">POA</span>

                      <!-- <span
                        class="price"
                        v-else-if="Number(watch.Price) > Number(sitePOA || Infinity)"
                      >
                        POA
                      </span> -->

                      <span class="price" v-else>
                        <span class="currency" v-if="watch.Currency === '£'">£</span>
                        <span class="currency" v-if="watch.Currency === 'CHF'">CHF</span>
                        <span class="currency" v-if="watch.Currency === 'USD'">$</span>
                        <span class="currency" v-if="watch.Currency === 'AED'">AED</span>
                        <span v-if="!watch.Currency" class="currency">£</span>
                        {{ $formatNumber(watch.Price) }}
                      </span>

                    </template>

                  </p>
                  <span class="description vhtml" v-html="watch.Description"></span>
                </div>

                <router-link
                  :to="{
                    name: 'rmwatch',
                    params: { watchSKU: watch.SKU, watchModel: watch.Model.split(' ').join('') }
                  }"
                >
                  <button v-if="watch.Name.length" class="right clean-link">
                    View more
                    <img class="center" src="/images/icons/ArrowRight.svg" />
                  </button>
                </router-link>
              </div>
            </section>
          </article>
        </div>
      </div>
    </div>

    <!-- Other Watches -->
    <div v-if="route === 'the-collection'">
      <div v-for="(watch, index) in otherWatches" :key="watch.SKU">
        <div
          class="page-grid"
          v-if="
            (loop === 0 && watch.SKU === featuredOther.first) ||
            (loop === 1 && watch.SKU === featuredOther.second) ||
            (loop === 2 && watch.SKU === featuredOther.third) ||
            (loop === 3 && watch.SKU === featuredOther.fourth)
          "
        >
          <article class="grid-container image-right columns-two border no-gap">
            <section class="section1">
              <span v-for="(img) in featuredOtherWatchesImgs" :key="img[0].SKU">
                <div
                  v-if="watch.SKU === img[0].SKU"
                  class="bg-image"
                  :style="{ backgroundImage: 'url(/watches/gallery/NW-' + watch.SKU + '/gallery-small-image/' + img[0].name + ')' }"
                ></div>
              </span>
            </section>

            <section class="section2 transparent">
              <div>
                <h2>{{ watch.Name }}</h2>
                <div>
                  <p>
                    <span v-if="watch.StatusName === 'Sold'">Sold</span>
                                          <span v-if="watch.isPOA" class="price">POA</span>

                    <!-- <span
                      class="price"
                      v-else-if="Number(watch.Price) > Number(sitePOA || Infinity)"
                    >
                      POA
                    </span> -->
                    <span class="price" v-else>
                      <span class="currency" v-if="watch.Currency === '£'">£</span>
                      {{ $formatNumber(watch.Price) }}
                    </span>
                    <span class="grid-status-divider">&nbsp;</span>
                    <span class="status">{{ watch.StatusName }}</span>
                  </p>
                  <span class="description vhtml" v-html="watch.Description"></span>
                </div>

                <router-link
                  :to="{
                    name: 'otherwatch',
                    params: {
                      watchManufacturerName: watch.ManufacturerName.split(' ').join('-'),
                      watchSKU: watch.SKU,
                      watchModel: watch.HTMLSafeModel.split(' ').join('')
                    }
                  }"
                >
                  <button v-if="watch.Name.length" class="right">
                    View
                    <img class="center" src="/images/icons/ArrowRight.svg" />
                  </button>
                </router-link>
              </div>
            </section>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: 'FeaturedWatches',
  props: {
    route: String,
    loop: Number,
    // sitePOA: String,
    // siteSettings: {
    //   type: Object,
    //   required: true
    // }
  },
  data() {
    return {
      rmWatches: [],
      otherWatches: [],
      featuredRM: [],
      featuredOther: [],
      featuredRMWatchesImgs: '',
      featuredOtherWatchesImgs: ''
    };
  },
  mounted() {
    this.getAllRMWatches();
    this.getAllOtherWatches();
    this.getFeaturedWatches();
    this.getFeaturedWatchesImgs();
  },
  methods: {
    getAllOtherWatches(address) {
      this.$axios.get(address || '/api/otherwatches').then((response) => {
        this.otherWatches = response.data.data;
      });
    },
    getAllRMWatches(address) {
      this.$axios.get(address || '/api/rmonly').then((response) => {
        this.rmWatches = response.data.data;
      });
    },
    getFeaturedWatches(address) {
      this.$axios.get(address || '/api/featuredwatches').then((response) => {
        this.featuredRM = response.data[0][0];
        this.featuredOther = response.data[1][0];
      });
    },
    getFeaturedWatchesImgs(address) {
      this.$axios.get(address || '/api/featuredwatchesimgs').then((response) => {
        this.featuredRMWatchesImgs = response.data[0];
        this.featuredOtherWatchesImgs = response.data[1];
      });
    }
  },
   computed: {
    ...mapGetters("auth", ["authUser"]),
    ...mapState('boutiques', ['londonboutique', 'siteSettings']), // pull from Vuex
    isExtended() {
      return this.expanded;
    },
  },
};
</script>
